export type BrowserNotificationPermissionState =
    | NotificationPermission
    | 'unsupported';

export function readBrowserNotificationPermission(): BrowserNotificationPermissionState {
    if (typeof Notification === 'undefined') {
        return 'unsupported';
    }

    return Notification.permission;
}

export async function ensureBrowserNotificationPermission(): Promise<BrowserNotificationPermissionState> {
    const permission = readBrowserNotificationPermission();
    if (permission === 'unsupported' || permission === 'granted') {
        return permission;
    }

    return Notification.requestPermission();
}
